import React from "react";
import { TodoContext } from '../TodoContext';
import { useLocalStorage } from "../TodoContext/useLocalStorage";
import '../style.css';
import './PageHeader.css';
import { FormattedMessage } from 'react-intl';

function PageHeader() {

  let date = new Date("February 24, 2022 00:00:00").getTime();
  setInterval(function() {
    let actualdate = new Date().getTime();
    let diff = actualdate - date;
    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
  document.getElementById("days").innerHTML = days;

  }, 1000);
  
  const { 
    saveThemeColor: saveColor,
  } = useLocalStorage('THEME_COLOR', '');

  const {
    setOpenModalList,
  } = React.useContext(TodoContext);

  const changeColor = (color) => {
    saveColor(color);
    if (color === 'red') {
      document.documentElement.style.setProperty('--color-primary', '#F75851')
      document.documentElement.style.setProperty('--color-secondary', 'rgb(214, 43, 49)')
      document.documentElement.style.setProperty('--color-highlight', '#f86f69')
    } else if (color === 'blue') {
      document.documentElement.style.setProperty('--color-primary', '#2CA3B5')
      document.documentElement.style.setProperty('--color-secondary', 'rgb(74,192,210)')
      document.documentElement.style.setProperty('--color-highlight', '#69d7f8')
    }
  };

    return (
        <div className="pageHeader">
          <div className="pageHeader--container">
            <a href="https://ivanr3d.com/"><img src="./logo192.png" alt="Logo web Ivan Artiles"/></a>
            <p><FormattedMessage id="pageheader.p" defaultMessage="Add your daily tasks here to keep a track of your progress!"/></p>
            <div className="colorSelector">
              <label className="red" onClick={() => changeColor('red')}>
                <input type="radio" name="color" value="red"/>
                <div className="layer"></div>
                <div className="button"><span></span></div>
              </label>

              <label className="blue" onClick={() => changeColor('blue')}>
                <input type="radio" name="color" value="blue"/>
                <div className="layer"></div>
                <div className="button"><span></span></div>
              </label>
            </div>
          </div>

          <div className="lists--container">
            <button onClick={setOpenModalList}><FormattedMessage id="lists.btn" defaultMessage="Preload list"/></button>
          </div>

          <div className="banner-w-heart">
          <div className="banner-w-heart--container">
            <span>Stand with <a href="https://supportukrainenow.org/" target="_blank" rel="noreferrer">Ukraine</a></span>
            <span><span id="days"></span> days of invasion</span>
          </div>
          <div id="heart"></div>
        </div>
        </div>
    );
}

export { PageHeader };